import React, { useState } from 'react'
import MenuItemCardListContainer from './container'
import { useOrder } from 'context/OrderContext'
import { useSelector } from 'react-redux'
import { useTheme } from '@mui/material'

const MenuItemCardList = ({ items, searchQuery, onSearchChange, isLoading = false }) => {
  const { orderType, addItemToOrder, removeItemFromOrder, getItemQuantity, getTotalQuantityById, lastAddedItem,
    updateDialogOpen, updateDialogItem, updateItemSelections, closeUpdateDialog, orderItems, openUpdateDialog, updateDialogFromAdd
  } = useOrder()
  const [selectedItem, setSelectedItem] = useState(null)
  const [addOnsDialogOpen, setAddOnsDialogOpen] = useState(false)
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
  const [itemForConfirmation, setItemForConfirmation] = useState(null)
  const [miscDialogOpen, setMiscDialogOpen] = useState(false)

  const theme = useTheme()

  const userData = useSelector((state) => state?.posData)

  const handleAddClick = (item) => {
    if (item.hasAddOns) {
      const qty = getTotalQuantityById(item.id)
      const variants = orderItems.filter(i => i.id === item.id);
      // if (qty > 0) {
      //   setItemForConfirmation(item)
      //   setConfirmDialogOpen(true)
      // } else {
      //   setSelectedItem(item)
      //   setAddOnsDialogOpen(true)
      // }

      if (variants.length > 1) {
        // ③ multiple variants → go straight to UpdateQuantity
        openUpdateDialog({ name: variants[0].name, variants });
      } else if (qty > 0) {
        // ② exactly one variant already in cart → Confirm Add-On dialog
        setItemForConfirmation(item);
        setConfirmDialogOpen(true);
      } else {
        // ① none yet → Add-Ons dialog
        setSelectedItem(item);
        setAddOnsDialogOpen(true);
      }

      // If item has add-ons, show dialog
      // setSelectedItem(item)
      // setAddOnsDialogOpen(true)
    } else {
      // If no add-ons, directly add to order
      addItemToOrder(item)
    }
  }
  const handleCloseAddOnsDialog = () => {
    setAddOnsDialogOpen(false)
    setSelectedItem(null)
  }

  const handleCloseConfirmation = () => {
    setConfirmDialogOpen(false)
    setItemForConfirmation(null)
  }

  const handleAddNew = () => {
    setConfirmDialogOpen(false)
    setSelectedItem(itemForConfirmation)
    setAddOnsDialogOpen(true)
    closeUpdateDialog();
  }

  // const handleRepeatLast = () => {
  //   if(lastAddedItem){
  //     addItemToOrder(lastAddedItem)
  //   }
  //   setConfirmDialogOpen(false)
  //   setItemForConfirmation(null)
  // }

  const handleRepeatLast = () => {
    if (itemForConfirmation) {
      const variants = orderItems.filter(i => i.id === itemForConfirmation.id);

      if (variants.length > 0) {
        // Pick the last-added variant of THIS item only
        const lastVariantOfThisItem = variants[variants.length - 1];

        addItemToOrder(lastVariantOfThisItem);
      }
    }

    setConfirmDialogOpen(false);
    setItemForConfirmation(null);
  };

  const handleOpenMiscDialog = () => setMiscDialogOpen(true)

  const handleCloseMiscDialog = () => setMiscDialogOpen(false)

  const handleSaveMiscItem = (values, { resetForm }) => {
    const priceEntered = values.price !== '' && values.price != null
    const parsedPrice = priceEntered ? parseFloat(values.price) : 0

    addItemToOrder({
      id: Date.now(),
      name: values.name.trim(),
      price: Number.isNaN(parsedPrice) ? 0 : parsedPrice,
      priceEntered,
      notes: values.notes?.trim() || '',
      hasAddOns: false,
      quantity: 1,
      isMisc: true,
      cookingRequired: values.cookingRequired || false,
      primary_chef_id: values.cookingRequired && values.chef ? values.chef.value : null,
      station_id: values.cookingRequired && values.chef ? (values.chef.station_id || null) : null,
    })

    resetForm()
    setMiscDialogOpen(false)
  }

  const filteredItems = isLoading ? [] : items.filter((item) => item.name.toLowerCase().includes(searchQuery.toLowerCase()))
  
  return (
    <>
      <MenuItemCardListContainer
        handleAddClick={handleAddClick}
        handleCloseAddOnsDialog={handleCloseAddOnsDialog}
        userData={userData}
        theme={theme}
        addOnsDialogOpen={addOnsDialogOpen}
        selectedItem={selectedItem}
        items={items}
        searchQuery={searchQuery}
        onSearchChange={onSearchChange}
        orderType={orderType}
        removeItemFromOrder={removeItemFromOrder}
        getItemQuantity={getItemQuantity}
        isLoading={isLoading}
        filteredItems={filteredItems}

        confirmDialogOpen={confirmDialogOpen}
        handleCloseConfirmation={handleCloseConfirmation}
        handleAddNew={handleAddNew}
        handleRepeatLast={handleRepeatLast}
        itemForConfirmation={itemForConfirmation}
        getTotalQuantityById={getTotalQuantityById}

        updateDialogOpen={updateDialogOpen}
        updateDialogItem={updateDialogItem}
        updateItemSelections={updateItemSelections}
        closeUpdateDialog={closeUpdateDialog}
        showAddNew={updateDialogFromAdd}

        miscDialogOpen={miscDialogOpen}
        handleOpenMiscDialog={handleOpenMiscDialog}
        handleCloseMiscDialog={handleCloseMiscDialog}
        handleSaveMiscItem={handleSaveMiscItem}
      />
    </>
  )
}

export default MenuItemCardList
